module.exports = __webpack_public_path__ + "img/重庆吾悦.99abbecb.png";